import { useMemo, useReducer } from 'react';
import { APP_VERSION } from '../version.generated';
import { CHANGELOG_MD } from '../changelog.generated';
import { parseChangelog } from '../changelog';
import { useAuth } from '../auth/AuthProvider';
import { Footer } from '../components/Footer';
import { ChangelogModal, changelogModalReducer } from '../components/ChangelogModal';
import { LoginScreen } from '../screens/login/LoginScreen';
import { AppShell } from './AppShell';

export function Root(): JSX.Element {
  const { session, errorCode, signingIn, login, logout } = useAuth();
  const [modal, dispatch] = useReducer(changelogModalReducer, { open: false });
  const entries = useMemo(() => parseChangelog(CHANGELOG_MD), []);
  const year = new Date().getFullYear();
  const openChangelog = (): void => dispatch({ type: 'open' });

  return (
    <>
      {session === null ? (
        <LoginScreen
          errorCode={errorCode}
          submitting={signingIn}
          onSubmit={(email, password) => {
            void login(email, password);
          }}
          onOpenChangelog={openChangelog}
        />
      ) : (
        <div className="app">
          <AppShell session={session} onLogout={() => void logout()} />
          <Footer version={APP_VERSION} year={year} onOpenChangelog={openChangelog} />
        </div>
      )}

      <ChangelogModal
        open={modal.open}
        currentVersion={APP_VERSION}
        entries={entries}
        onClose={() => dispatch({ type: 'close' })}
      />
    </>
  );
}
